export default "__VITE_ASSET__Dp26okuX__"